/**
 * MarketNav Component
 * Collapsible market navigation - shows different markets based on module
 * Created: 2025-12-23 17:30 EST
 */

import { useState, useEffect } from 'react'
import './MarketNav.css'

// Markets configuration per module
const MODULE_MARKETS = {
  Odds: [
    { name: 'Moneyline', icon: 'fas fa-dollar-sign' },
    { name: 'Spreads', icon: 'fas fa-arrows-alt-h' },
    { name: 'Totals', icon: 'fas fa-plus-minus' },
    { name: 'Game Props', icon: 'fas fa-gamepad' },
    { name: 'Team Props', icon: 'fas fa-users' },
    { name: 'Player Props', icon: 'fas fa-user' },
    { name: 'Futures', icon: 'fas fa-calendar-alt' },
    { name: 'All', icon: 'fas fa-th' }
  ],
  Stats: [
    { name: 'Team Stats', icon: 'fas fa-users' },
    { name: 'Player Stats', icon: 'fas fa-user' },
    { name: 'Trends', icon: 'fas fa-chart-line' }
  ],
  Models: [
    { name: 'Win Probability', icon: 'fas fa-percentage' },
    { name: 'Score Prediction', icon: 'fas fa-bullseye' },
    { name: 'Player Props', icon: 'fas fa-user' }
  ],
  Arbitrage: [
    { name: 'Pre-Game', icon: 'fas fa-calendar' },
    { name: 'Live', icon: 'fas fa-bolt' }
  ],
  Middles: [
    { name: 'Spreads', icon: 'fas fa-arrows-alt-h' },
    { name: 'Totals', icon: 'fas fa-plus-minus' }
  ],
  PositiveEV: [
    { name: 'All Markets', icon: 'fas fa-chart-line' }
  ],
  '+EV': [
    { name: 'All Markets', icon: 'fas fa-chart-line' }
  ]
}

// Ticker messages - market specific
const TICKER_MESSAGES = [
  'COMPARE LINES',
  'MONEYLINE',
  'SPREADS',
  'TOTALS',
  'PLAYER PROPS',
  'FUTURES'
]

function MarketNav({
  selectedModule,
  selectedMarket,
  onMarketSelect,
  collapsed,
  onToggleCollapse
}) {
  // Get markets for current module
  const markets = MODULE_MARKETS[selectedModule] || []

  // Auto-select first market when module changes
  useEffect(() => {
    if (markets.length > 0 && !markets.find(m => m.name === selectedMarket)) {
      onMarketSelect(markets[0].name)
    }
  }, [selectedModule, markets, selectedMarket, onMarketSelect])

  // Don't render if no markets for this module
  if (markets.length === 0) {
    return null
  }

  return (
    <div className={`market-nav-section ${collapsed ? 'collapsed' : ''}`}>
      {/* Collapse Toggle */}
      <button
        className="market-nav-toggle"
        onClick={onToggleCollapse}
        title={collapsed ? 'Expand Markets' : 'Collapse Markets'}
      >
        <span className="toggle-label">{selectedMarket}</span>

        {/* Ticker - scrolls REVERSE direction */}
        <div className="market-ticker-container">
          <div className="market-ticker-scroll-reverse">
            {TICKER_MESSAGES.map((msg, i) => (
              <span key={i}>
                {msg}
                <span className="separator-market">•</span>
              </span>
            ))}
            {/* Duplicate for seamless loop */}
            {TICKER_MESSAGES.map((msg, i) => (
              <span key={`dup-${i}`}>
                {msg}
                <span className="separator-market">•</span>
              </span>
            ))}
          </div>
        </div>

        <i className={`fas fa-chevron-${collapsed ? 'down' : 'up'}`}></i>
      </button>

      {/* Market Navigation */}
      {!collapsed && (
        <nav className="market-nav">
          {markets.map((market) => (
            <button
              key={market.name}
              className={`market-btn ${selectedMarket === market.name ? 'active' : ''}`}
              onClick={() => onMarketSelect(market.name)}
            >
              <i className={market.icon}></i>
              <span>{market.name}</span>
            </button>
          ))}
        </nav>
      )}
    </div>
  )
}

export default MarketNav
